import React from 'react';
import { Field } from 'redux-form';
import { DatePicker } from 'material-ui';
import moment from 'moment';
import req from 'superagent';
import cfg from 'cfg';
import RFSelect from './RFSelect';

const eventRender = event => (
    <span>
        {event.homeName} - {event.awayName}
    </span>
);

class EventPicker extends React.PureComponent {
    state = { date: undefined, events: [] };

    onDateChange = (event, date) => {
        this.setState({ date, events: [] });
        const formatted = moment(date).format('YYYY-MM-DD');
        req
            .get(cfg.apis.ss2 + '/events/soccer/' + formatted)
            .then(({ body }) => {
                this.setState({ events: body });
            })
            .catch(console.log);
    };

    render() {
        const { name = 'eventId' } = this.props;
        const { events = [] } = this.state;
        return (
            <div>
                <DatePicker
                    name={'date'}
                    floatingLabelText={'Event date'}
                    value={this.state.date}
                    onChange={this.onDateChange}
                />
                <Field
                    name={name}
                    ignoreCase
                    matchProp={'any'}
                    options={events}
                    optionRenderer={eventRender}
                    valueRenderer={eventRender}
                    valueKey={'eventId'}
                    placeholder={'Event (match)'}
                    component={RFSelect}
                />
            </div>
        );
    }
}

export default EventPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/EventPicker.js
 **/